import * as fb from '@/plugins/firebase'

export const state = {
    users: [],
}

export const mutations = {
    setUsers(state, users) {
        state.users = users
    },
}

export const actions = {

    async loadUsers({commit}) {

        let allUsers = await fb.usersCollection.get()

        allUsers = allUsers.docs.map(docUser => {
            let userData = Object.assign({}, docUser.data())
            userData.id = docUser.id
            return userData
        })

        commit('setUsers', allUsers)
    },

}


export default {
    state,
    actions,
    mutations,
};
